import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/spaces')({
  component: SpacesLayout,
});

function SpacesLayout() {
  return <Outlet />;
}
